<template>
    <div class="group">
        <div class="page-group-title"><span>商品套图</span></div>
        <el-upload class="upload-demo" drag action="" multiple style="width: 75%; margin-bottom: 20px;" :show-file-list="false"
             :accept="accept" :http-request="uploadAction" :disabled="ssList && ssList.length > 10 ? true : false" 
           >
            <i class="el-icon-upload"></i>
            <div class="el-upload__text">
                将图片或视频拖到此处，或
                <em>点击选择照片</em>
                （仅支持.png、.jpg或.mp4）
                <div>可批量选择我文件，最多选择10个文件</div>
            </div>
        </el-upload>
        <div class="list-wrap">
            <el-row :gutter="30" type="flex">
                <el-col v-if="wList && wList.length > 0" :sm="eList && eList.length > 0 ? 12 : 24">
                    <el-card>
                        <div slot="header" class="c-head color-warning">
                            <span>上传中&待上传（{{ wList.length }}个）</span>
                            <el-button size="mini" type="primary" icon="el-icon-upload" :loading="uploading"
                                @click="uploadFiles">点击上传</el-button>
                        </div>
                        <el-table :data="wList" size="mini">
                            <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="type" label="格式"></el-table-column>
                            <el-table-column prop="size" label="大小">
                                <template slot-scope="{row} = scope">{{ (row.size / 1024 / 1024).toFixed(2)
                                }}M</template>
                            </el-table-column>
                            <el-table-column>
                                <template slot-scope="{row} = scope">
                                    <el-progress :percentage="row.progress || 0" :show-text="false"></el-progress>
                                </template>
                            </el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
                <el-col v-if="eList && eList.length > 0" :sm="wList.length > 0 ? 12 : 24">
                    <el-card>
                        <div slot="header" class="color-danger">上传失败（{{ eList.length }}个）</div>
                        <el-table :data="eList" size="mini">
                            <el-table-column prop="name" label="名称" show-overflow-tooltip></el-table-column>
                            <el-table-column prop="type" label="格式"></el-table-column>
                            <el-table-column prop="size" label="大小">
                                <template slot-scope="{row} = scope">{{ (row.size / 1024 / 1024).toFixed(2)
                                }}M</template>
                            </el-table-column>
                            <el-table-column prop="err" label="原因" show-overflow-tooltip></el-table-column>
                        </el-table>
                    </el-card>
                </el-col>
            </el-row>
            <el-card v-if="ssList && ssList.length > 0" class="MT20">
                <div slot="header" class="color-success">已上传（{{ ssList.length }}/10）<small
                        class="color-info">可拖拽排序</small></div>
                <el-row :gutter="20" type="flex" class="s-list">
					<vuedraggable v-model="ssList" draggable=".img" @change="updateSort">
						<el-col v-for="(item, index) in ssList" :key="index"  class="img">
							<div class="item"  v-if="item.type == 1">
								<el-image :src="item.pic" fit="cover" lazy></el-image>
								<div class="tool">
									<div>
										<span class="preview el-icon-view" @click="preview(index)"></span>
										<el-button icon="el-icon-delete" type="text" @click="del(index)"></el-button>
									</div>
								</div>
							</div>
							<div class="item" v-else>
								<video :src="item.videoUrl"></video>
								<div class="tool">
									<div>
										<span class="preview el-icon-view" @click="preview(index)"></span>
										<el-button icon="el-icon-delete" type="text" @click="del(index)"></el-button>
									</div>
								</div>
							</div>
						</el-col>
					</vuedraggable>
                </el-row>
            </el-card>
        </div>
        <el-image-viewer v-if="showViewer && imageViewerUrl" :on-close="() => { showViewer = false }"
            :url-list="[imageViewerUrl]" :z-index="100000" />
        <video-play ref="videoPlay"></video-play>
    </div>
</template>
<script>
import { uploadVideo, uploadImg } from '@/assets/js/commonApi.js';
import ElImageViewer from 'element-ui/packages/image/src/image-viewer';
import VideoPlay from "@/components/VideoPlay";
import vuedraggable from 'vuedraggable';
export default {
    props: {
        sList: {
            type: Array,
            default: () => [],
        }
    },
    components: { ElImageViewer, VideoPlay, vuedraggable },
    data() {
        return {
            progress: '',
            wList: [], //待上传文件列表
            // sList: [], //上传成功文件列表
            eList: [], //上传失败列表
            accept: 'image/jpeg,image/png,video/mp4',
            // previewList: [],
            btnLoading: false,
            uploading: false,
            showViewer: false,
            imageViewerUrl: "",
			sList2:[],
			ssList:this.sList
        }
    },
    mounted() {
      
    },
    methods: {
        // getWList() {
        //     return this.wList;
        // },
        //文件超出个数限制时的钩子	
        uploadExceed(files, fileList) {
            this.$message.warning(`当前限制选择 10 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
        },
        fileJson(file) {
            return {
                name: file.name,
                size: file.size,
                type: file.type,				
            }
        },
        setProgress(ev, _uuid) {
            const progress = Math.floor((ev.loaded / ev.total) * 20);

            this.wList.map((v, i) => {
                if (v.uuid == _uuid) {
                    v.progress = progress;
                    if (Math.floor((ev.loaded / ev.total)) == 1) {
                        const t = setInterval(() => {
                            if (v.progress && v.progress < 99) {
                                v.progress += 1;
                            } else {
                                clearInterval(t);
                            }
                        }, 1000)
                    }
                }
            })
        },
        //上传事件
        async uploadAction(req) {			
			
			var tList = this.wList.length + this.ssList.length
			
			if( this.ssList.length >= 10 || tList >= 10 ){
				this.$message.error('最多只能上传10个文件');
				return
			}
			
            const { file } = req;
            const _maxSize_img = 1024 * 1024 * 10, _maxSize_video = 1024 * 1024 * 100;
            let _accept = this.accept.split(',') || [];

            _accept.map((item, index) => {
                _accept[index] = item.trim();
            })
            if (!_accept.find(v => v == file.type)) {
                this.eList.push({
                    ...this.fileJson(file),
                    err: '文件格式错误',
                });
                return;
            }

            if (file.type != "video/mp4" && file.size > _maxSize_img) {
                this.eList.push({
                    ...this.fileJson(file),
                    err: '图片大小大于10M',
                });
                return;
            }
            if (file.type == "video/mp4" && file.size > _maxSize_video) {
                this.eList.push({
                    ...this.fileJson(file),
                    err: '视频大小大于30M',
                });
                return;
            }

           
            const _uuid = this.$utils.uuid();
            this.wList.push({
                ...this.fileJson(file),
                progress: 0,
                uuid: _uuid,
                file: file
            });
			
        },
        async uploadFiles() {
            await this.uploadRequest(this.wList[0].file, this.wList[0].uuid);          
        },
        async uploadRequest(file, _uuid) {
			
			if( this.ssList.length >= 10 ){
				this.$message.error('最多只能上传10个文件');
				return
			}
            this.uploading = true;
            const fileData = new FormData();
            fileData.append('file', file);
			
			var type = file.type == "video/mp4" ? 2 : 1 ; //类型 1:图片 2:视频
            const res = await (file.type == "video/mp4" ? uploadVideo : uploadImg)(
                fileData,
                (ev) => {
                    this.setProgress(ev, _uuid)
                }
            )
                .catch(() => {
                    this.eList.push({
                        ...this.fileJson(file),
                        err: '上传失败',
                    });
                })
                .finally(() => {
                    this.wList.map((v, i) => {
                        if (v.uuid == _uuid) {
                            v.progress = 99;
                            // const t = setTimeout(() => {
                            //     // this.wList[i].uploadLoading = false;
                            //     clearInterval(t);
                            // }, 800);
                        }
                    })
                    const t1 = setTimeout(async () => {
                        this.wList = this.wList.filter(item => item.uuid != _uuid)
                        this.uploading = false;

                        if (this.wList.length > 0) {
                            await this.uploadRequest(this.wList[0].file, this.wList[0].uuid);
                        }

                        clearInterval(t1);
                    }, 1000);
                });

            const { state, result, msg } = res.data;
            if (state == 1 && result) {
				
				var pic = file.type == "video/mp4" ? '' : result.urlFull ;
				var videoUrl =  file.type == "video/mp4" ? result.urlFull : '';
				
				var obj = {
					pic: pic,
					type:type,
					videoUrl:videoUrl
				}
				//this.sList.push(result.urlFull)                				
				this.ssList.push(obj)
				
				
            } else {
                this.eList.push({
                    ...this.fileJson(file),
                    err: msg || '上传失败',
                });
            }
        },
        //预览
        preview(index) {
            const _type = this.sList[index].type;
            if ( _type == 2) {
                this.$refs.videoPlay.show({ url: this.sList[index].videoUrl });
            } else {
                this.showViewer = true;
                this.imageViewerUrl = this.sList[index].pic;
            }
        },
		updateSort(){
			this.$emit("update:sList", this.ssList);			
		},
        del(index) {
			var delsList = this.ssList
			delsList.forEach((itm,idx) => {				
				if( idx == index ){
					delsList.splice(index,1)
				}
			})
			this.$emit("update:ssList", delsList);
			this.$emit("update:sList", delsList);	
			
        }
    },
}
</script>

<style lang="scss" scoped>
::v-deep .el-upload,
::v-deep .el-upload-dragger {
    width: 100%;
    height: 80px;

    .el-icon-upload {
        margin: 5px 0 0px 0;
        font-size: 20px;
        line-height: 20px;
    }

    .el-upload__text {
        line-height: normal;
        padding: 0 40px;
        font-size: 12px;
    }
}

.list-wrap {
    .el-col {
        margin-top: 20px;

        .el-card {
            height: 100%;

            .c-head {
                display: flex;
                align-items: center;
                justify-content: space-between;
            }

            .file-list {
                .file {
                    margin: 8px 0;
                }
            }
        }
    }
}

.s-list {
    flex-wrap: wrap;

    .el-col {
        width: 240px;
        margin: 10px 0;

        .item {
            border: 1px #eee solid;
            border-radius: 4px;
            overflow: hidden;
            position: relative;

            .el-image,
            video {
                width: 100%;
                height: 140px;
                vertical-align: middle;
                object-fit: cover;
            }

            .tool {
                position: absolute;
                background: rgba(0, 0, 0, 0.5);
                width: 100%;
                height: 100%;
                left: 0;
                top: 0;
                display: none;
                align-items: center;
                justify-content: center;

                .el-button,
                .preview {
                    color: #ffffff;
                    font-size: 18px;
                    font-weight: 700;
                    margin: 0 5px;
                }

                .preview {
                    cursor: pointer;
                }
            }

            &:hover {
                .tool {
                    display: flex;
                }
            }
        }

    }
}

@media screen and (max-width: 768px) {
    .el-row {
        flex-wrap: wrap;
    }
}
</style>